module.exports = __webpack_public_path__ + "img/clara_luciani.1e414756.jpg";